//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { demandTypeList } from './data';
import portal from '~/net/portal';
import { searchCodes } from '~/constant/SearchCodes';
import config from '~/config';
import myProgress from '~/components/Myprogress';
import ChatBox from '~/components/ChatBoxNew';
export default {
  head() {
    return {
      title: '需求详情',
      meta: [
        { hid: 'keywords', name: 'keywords', content: this.demand.name },
        { hid: 'description', name: 'description', content: this.demand.summary },
      ],
    };
  },
  computed: {
    difyKeyword() {
      return this.demand?.difyKeyword?.replace(/[,，]/g, ' ') ?? '';
    },
    ...mapState(['user', 'identities']),
    // routes() {
    // if (this.demand.confThemeActivityId == '202410602943614795' && localStorage.getItem('navigationType') == 'lasa') {
    //     return [{ name: '拉萨首页', path: '/lasaDemand/home' }, { name: '需求列表', path: '/lasaDemand/demandList' }, { name: this.demand.name }]
    // }
    //     return [{ name: '首页', path: '/' }, { name: '需求', path: '/crowdsourcing' }, { name: '需求列表', path: '/crowdsourcing/demandList' }, { name: this.demand.name }]
    // },
    isTechManager() {
      return (
        this.user != null &&
        this.identities.length > 0 &&
        this.identities.find((_) => _.type == '01' && _.isBind != 2)
      );
    },
    isSelf() {
      if (this.user !== null && this.demand.userId !== null) {
        return this.user.id == this.demand.userId;
      }
      return false;
    },
    isValid() {
      if (this.demand.status == '02' || this.demand.status == '07' || this.demand.status == '10') {
        return true; // 发布中 & 解决中 & 申请撤销
      }
      return false;
    },
    currentPageDemands() {
      return this.recommandDemands.slice((this.currentPage - 1) * 4, this.currentPage * 4);
    },
    systemTags() {
      if (this.demand.systemTag) {
        return this.demand.systemTag.split(',');
      } else {
        return [];
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        this.$nextTick(() => {
          // 不加this.$nextTick时，路由跳转后还是上一次的数据，所以需要加上
          this.getRoutes(); // 需要执行的方法
        });
      }
    },
  },
  async asyncData(context) {
    // resp2,
    try {
      const [resp2, resp3] = await Promise.all([
        // portal.getDemandDetail({
        //   query: {
        //     demandId: context.query.id,
        //   },
        //   client: context.req,
        // }),
        portal.getRecommendDemandsList({
          query: {
            demandId: context.query.id,
            num: 12,
          },
          client: context.req,
        }),
        portal.judgeCollected({
          query: {
            id: context.query.id,
            type: '02',
          },
          client: context.req,
        }),
      ]);
      // let data1;
      // if (resp1.code == '0000') {
      //   data1 = resp1.data;
      //   console.log(data1, 'demand');
      // } else {
      //   context.error({ statusCode: resp1.statusCode, messsage: resp1.message });
      // }
      const data3 = resp3.data;
      console.log(data3, 'collection');
      return {
        // demand: data1,
        recommandDemands: (resp2.code === '0000' && resp2.data) || [],
        demandId: context.query.id,

        collectionStatus: data3 == '01',
      };
    } catch (error) {
      console.log(error);
    }
  },
  created() {
    if (this.$route.query.id != undefined) {
      this.page.demandId = this.$route.query.id;
      this.demandId = this.$route.query.id;
      this.getCrowdSourceDemandSolveDynamic();
      this.getDemandDetail();
    }
  },
  mounted() {
    this.getRoutes();
  },
  validate({ query }) {
    return !!query.id;
  },
  components: {
    myProgress,
    ChatBox,
  },
  watchQuery: ['id'],
  data() {
    return {
      baseURl: typeof window === 'undefined' ? config.PortalBaseURL : config.PortalBrowserBaseURL,
      collectionStatus: false,
      typeChatBox: null,
      wenjuanExpand: true,
      showChatBox: false,
      questionsArray: [
        '目前哪些机构有相似的技术需求?',
        '该需求的技术路线 ?',
        '为该需求推荐相关的科技成果 ?',
      ],
      routes: [],
      maxLimit: 3,
      demandId: '',
      tipVisiable: false,
      collectionVisible: false,
      modal: {
        content: '',
        buttonText: '',
        url: '',
      },
      demandTypeList,
      refresh: false,
      codes: searchCodes,
      businessBrowserUrl: config.businessBrowserUrl,
      demand: {},
      realPhone: '',
      showHeader: false,
      total: 0,
      lastPage: false,
      page: {
        page: 1,
        rows: 15,
        keyword: '',
        isAgent: 1,
        demandId: 1,
      },
      selection: [],
      matchOperation: {
        ids: [],
        advice: '',
      },
      goodsList: [],
      maxPage: 3,
      currentPage: 1,
      recommandDemands: [],
      // recommandTechs: [],
      recenteNewsList: [],
      showGoodVisible: false,
      matchedGoodVisible: false,
      agentSuccess: false,
      columns1: [
        {
          width: 20,
        },
        {
          type: 'selection',
          width: 24,
          align: 'left',
        },
        {
          width: 47,
          align: 'left',
          render: (h, params) => {
            console.log(params);
            return h('img', {
              class: 'goodsPic',
              attrs: {
                src: params.row.titleImgUrl
                  ? this.$absUrl(params.row.titleImgUrl)
                  : require('../../assets/images/antincp/default.png'),
              },
            });
          },
        },
        {
          width: 210,
          key: 'goodsName',
          align: 'left',
          render: (h, params) => {
            return <span class="texts">{params.row.goodsName}</span>;
          },
        },
        {
          width: 36,
          align: 'center',
          key: 'recommended',
          render: (h, params) => {
            return <i class={params.row.recommended ? 'iconfont icon-diamond' : ''}></i>;
          },
        },
        {
          width: 50,
          key: 'matchingRate',
          render: (h, params) => {
            if (params.row.matchingRate && params.row.matchingRate > 0) {
              return (
                <Tooltip trigger="hover" placement="top" content="需求与商品契合度">
                  <myProgress percent={params.row.matchingRate}></myProgress>
                </Tooltip>
              );
            } else {
              return <span class="texts"></span>;
            }
          },
        },
        {
          width: 7,
        },
        {
          width: 72,
          align: 'left',
          render: (h, params) => {
            return <span class="texts">{params.row.ownerName}</span>;
          },
        },
        {
          width: 75,
          render: (h, params) => {
            if (params.row.agent == false)
              return <Button onClick={() => this.applyAgentAsync(params.row.goodId)}>代理</Button>;
            else return '';
          },
        },
      ],
      columns2: [
        {
          width: 20,
        },
        {
          width: 47,
          align: 'left',
          render: (h, params) => {
            return h('img', {
              class: 'goodsPic',
              attrs: {
                src: params.row.titleImgUrl
                  ? this.$absUrl(params.row.titleImgUrl)
                  : require('../../assets/images/antincp/default.png'),
              },
            });
          },
        },
        {
          width: 230,
          key: 'goodsName',
          align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: 'texts',
              },
              params.row.goodsName
            );
          },
        },
        {
          width: 36,
          align: 'center',
          key: 'recommended',
          render: (h, params) => {
            return h('i', {
              class: params.row.recommended ? 'iconfont icon-diamond' : '',
            });
          },
        },
        {
          width: 70,
          key: 'matchingRate',
          render: (h, params) => {
            return (
              <Tooltip trigger="hover" placement="right" content="需求与商品契合度">
                <myProgress percent={params.row.matchingRate}></myProgress>
              </Tooltip>
            );
          },
        },
        {
          width: 7,
        },
        {
          width: 78,
          key: 'ownerName',
          align: 'right',
          render: (h, params) => {
            return h(
              'span',
              {
                class: 'texts',
              },
              params.row.ownerName
            );
          },
        },
        {
          width: 50,
        },
      ],
    };
  },
  methods: {
    // 我要服务
    serviceClick() {
      if (this.demand.serviceStatus == '01') {
        this.$Message.info('该项目已经在您的服务列表中了');
        return;
      }
      portal
        .demandServiceClick({
          query: {
            demandId: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.code === '0000') {
            this.getDemandDetail();
          }
        });
    },
    getDemandDetail() {
      portal
        .getDemandDetail({
          query: {
            demandId: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.code === '0000') {
            this.demand = res.data;
          }
        });
    },
    closeChatBox() {
      this.showChatBox = false;
      this.$refs.ChatBoxRef.clearAnswers();
    },
    askQuestion(value, type) {
      if (!this.user) {
        this.loginVisible = true;
        return;
      }
      this.typeChatBox = type === 2 ? 1 : 0;
      this.showChatBox = true; // 点击问题时也显示聊天框
      if (this.wenjuanExpand) {
        this.$nextTick(() => {
          this.$refs.ChatBoxRef.generateAnswer(value);
        });
      }
    },
    getRoutes() {
      console.log('demand =>', this.demand);
      if (this.$route.query.root == 'finance') {
        this.routes = [{ name: '科技金融首页', path: '/finance' }, { name: this.demand.name }];
        console.log(this.routes);
        return;
      }
      if (this.$route.query.root == 'financeDemandList') {
        this.routes = [
          { name: '科技金融首页', path: '/finance' },
          {
            name: '需求列表',
            path: '/demandDashboard?root=financeDemandList&type=0&demandType=07',
          },
          { name: this.demand.name },
        ];
        console.log(this.routes);
        return;
      }
      if (
        this.demand.confThemeActivityId == '202410602943614795' &&
        localStorage.getItem('navigationType') == 'lasa'
      ) {
        this.routes = [
          { name: '拉萨首页', path: '/lasaDemand/home' },
          { name: '需求列表', path: '/lasaDemand/demandList' },
          { name: this.demand.name },
        ];
        return;
      }
      // this.demand.confThemeActivityId == '202428303021097797' &&
      if (localStorage.getItem('navigationType') == 'gaoxiao') {
        this.routes = [
          { name: '高校首页', path: '/collegeHome' },
          { name: '技术需求', path: '/presentationDemand' },
          { name: this.demand.name },
        ];
        return;
      }
      this.routes = [
        { name: '首页', path: '/' },
        { name: '需求', path: '/crowdsourcing' },
        { name: '需求列表', path: '/crowdsourcing/demandList' },
        { name: this.demand.name },
      ];
    },
    getTitleHh(text) {
      if (text) {
        console.log(text);
        text = text.toString();
        console.log(text);
        return text
          .replace(/[^\x00-\xFF]/g, '$&\x01')
          .replace(/.{20}\x01?/g, '$&\n')
          .replace(/\x01/g, '');
      }
    },
    goto() {
      this.$router.push({
        path: '/login',
        query: {
          callback: window.location.href,
        },
      });
    },
    getStage() {
      let stage = '';
      switch (this.demand.stage) {
        case '00':
          stage = '实验室';
          break;
        case '01':
          stage = '小试';
          break;
        case '02':
          stage = '中试';
          break;
        case '03':
          stage = '产业化';
          break;
      }
      return stage;
    },
    getPublishType() {
      if (this.demand.publisherType == '0') {
        return '个人';
      } else {
        return '单位';
      }
    },
    getTags() {
      if (typeof this.demand.demandTags != 'undefined') {
        return this.demand.demandTags.join(',');
      } else return '';
    },
    getRegion() {
      if (typeof this.demand.region != 'undefined') {
        return this.demand.region.split(',');
      } else return [];
    },
    getCooperationMode() {
      let cooperationMode = '';
      switch (this.demand.cooperationMode) {
        case '00':
          cooperationMode = '股权投资';
          break;
        case '01':
          cooperationMode = '技术转让';
          break;
        case '02':
          cooperationMode = '许可使用';
          break;
        case '03':
          cooperationMode = '合作开发';
          break;
        case '04':
          cooperationMode = '合作兴办新企业';
          break;
        case '05':
          cooperationMode = '其他';
          break;
        case '06':
          cooperationMode = '技术咨询';
          break;
        case '07':
          cooperationMode = '技术服务';
          break;
        case '20':
          cooperationMode = '银行贷款';
          break;
        case '21':
          cooperationMode = '股权融资';
          break;
      }
      return cooperationMode;
    },
    async getCrowdSourceDemandSolveDynamic() {
      const { code, data } = await portal.getCrowdSourceDemandSolveDynamic({
        query: { demandId: this.demandId },
      });
      if (code === '0000') {
        this.recenteNewsList = data;
      }
    },
    resolve() {
      if (!this.user) {
        this.showModal(1);
      } else if (this.user.userStatus !== 2 && this.user.userStatus !== 5) {
        this.showModal(2);
      } else {
        this.$router.push('/crowdsourcing/resolve?id=' + this.demandId);
      }
    },
    showModal(type) {
      if (type == 1) {
        this.modal = {
          content: '您尚未登录，请登录后再进行提交',
          buttonText: '立即登录',
          url: () => {
            return this.$router.push('/login');
          },
        };
      } else if (type == 2) {
        this.modal = {
          content: '您尚未实名认证，请实名认证后再进行提交',
          buttonText: '立即实名认证',
          url: () => {
            return (window.location.href = `${this.businessBrowserUrl}/realname`);
          },
        };
      }
      this.tipVisiable = true;
    },
    getDemandStatus() {
      switch (this.demand.status) {
        case '00':
          return '未上架';
        case '01':
          return '未发布';
        case '02':
          return '发布中';
        case '03':
          return '审核不通过';
        case '04':
          return '已解决';
        case '05':
          return '审核中';
        case '06':
          return '已过期';
        case '07':
          return '解决中';
        case '09':
          return '已删除';
        case '10':
          return '审核中';
        case '16':
          return '待确认';
        case '18':
          return '无效需求';
        case '14':
          return '已完成';
        // case '01':
        //     return '未发布'
        // case '02':
        //     return '待解决'
        // case '03':
        //     return '已撤销'
        // case '04':
        //     return '已解决'
        // case '05':
        //     return '申请恢复'
        // case '06':
        //     return '已过期'
        // case '07':
        //     return '解决中'
        // case '09':
        //     return '已删除'
        // case '10':
        //     return '申请撤销'
        // case '16':
        //     return '待确认'
        // case '18':
        //     return '无效需求'
        // case '14':
        //     return '已完成'
        default:
          return '未知状态';
      }
    },
    getOrigin() {
      switch (this.demand.origin) {
        case '00':
          return '自主填报';
        case '01':
          return '政府';
        case '02':
          return '服务机构';
        case '03':
          return '技术经理人';
      }
    },
    getType() {
      switch (this.demand.type) {
        case '00':
          return '关键技术研发';
        case '01':
          return '产品升级';
        case '02':
          return '技术改造';
        case '03':
          return '设备改进';
        case '04':
          return '技术交易';
        case '05':
          return '技术咨询';
        case '06':
          return '海外创新合作';
        case '07':
          return '科技金融';
        case '99':
          return '其他';
      }
    },
    getOverallDemandType() {
      return this.demandTypeList.find((_) => _.code == this.demand.type).value;
    },
    makeMatch() {
      this.page.isAgent = '';
      this.page.keyword = '';
      this.newGetData();
    },
    newGetData() {
      this.goodsList = [];
      this.selection = [];
      this.matchOperation.ids = [];
      this.lastPage = false;
      this.page.page = 1;
      this.getAssociatedGoodsAsync();
    },
    async getAssociatedGoodsAsync() {
      const { code, data } = await this.$api.getAssociatedGoodsByCrowdSource({
        ...this.page,
      });
      this.total = data.total;
      if (data.rows)
        data.rows.forEach((item) => {
          // item._disabled = item.agent == false
          this.goodsList.push(item);
        });
      this.lastPage = data.lastPage;
      this.showGoodVisible = true;
      if (this.page.isAgent == 1 && this.goodsList.length <= 0) {
        this.page.isAgent = 0;
        this.getAssociatedGoodsAsync();
      }
    },
    reachBottom() {
      // if (this.lastPage) {
      //   this.$Message.info('没有更多商品了');
      // } else {
      //   this.page.page += 1;
      //   this.getAssociatedGoodsAsync();
      // }
    },
    selectionChange(value) {
      this.selection = value;
      this.matchOperation.ids = [];
      this.matchOperation.ids = this.selection.map((_) => _.goodId);
      if (this.selection.length > this.maxLimit) {
        this.$Message.info(`选择撮合的商品数量不能超过${this.maxLimit}个`);
      }
    },
    show4() {
      this.matchOperation.advice = '';
      this.matchedGoodVisible = true;
    },
    doMakeMatch() {
      if (this.matchOperation.advice.length > 500) {
        this.$Message.error('撮合建议不能超过500字');
        return;
      }
      portal
        .doMakeMatch({
          body: {
            demandId: this.page.demandId,
            suggestion: this.matchOperation.advice,
            goodIdList: this.matchOperation.ids,
          },
        })
        .then((res) => {
          const { code, data, message } = res;
          if (code === '0000') {
            this.matchedGoodVisible = false;
            this.showGoodVisible = false;
            this.$Message.success('撮合成功');
          }
        });
    },
    async applyAgentAsync(goodsId) {
      this.$Modal.confirm({
        title: '申请代理',
        content: '确认申请此商品的代理权吗?',
        onOk: async () => {
          const { code, data, message } = await portal.applyAgent({
            query: { goodsId },
          });
          if (code === '0000') {
            this.agentSuccess = true;
          }
          if (code === '131147') {
            this.$Message.warning('您必须要有一个自己店铺才能代理商品');
          }
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        },
      });
    },
    more() {
      this.refresh = true;
      setTimeout(() => {
        this.refresh = false;
        if (this.currentPage + 1 > 3 || this.currentPage + 1 > this.recommandDemands.length / 4) {
          this.currentPage = 1;
        } else this.currentPage++;
      }, 500);
    },
    collection() {
      if (this.user == null) {
        this.loginVisible = true;
        return;
      }
      if (this.user !== null) {
        this.collectionVisible = true;
      }
    },
    // 收藏需求  传收藏id  命名接口 demandCollection
    collectionConfirm() {
      portal
        .setCollectStatus({
          query: {
            id: this.demandId,
            type: '02',
            status: this.collectionStatus ? '00' : '01',
          },
        })
        .then((res) => {
          const { code, message } = res;
          if (code === '0000') {
            this.collectionVisible = false;
            this.collectionStatus = !this.collectionStatus;
            if (!this.collectionStatus) this.$Message.success('收藏成功');
            else this.$Message.success('已取消收藏');
          }
        });
    },
  },
};
